import { Box, Switch, TextField, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";

const SMILIES = ["😡", "😟", "😐", "🙂", "😍"];
const DEFAULT_LABELS = ["Terrible", "Bad", "Okay", "Good", "Great"];

const glassCard = { p: 2, borderRadius: 3, bgcolor: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)", border: "1px solid rgba(229,231,235,0.6)", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" };

const RatingTab = ({ skipOption, setSkipOption, errorMessage, setErrorMessage, settings, setSettings }) => {
  const ratingType = settings?.ratingType || "stars";
  const ratingLabels = settings?.ratingLabels || DEFAULT_LABELS;

  const handleLabelChange = (i, val) => {
    const updated = [...ratingLabels];
    updated[i] = val;
    setSettings({ ...settings, ratingLabels: updated });
  };

  const getPreview = (i) => {
    if (ratingType === "smilies") return SMILIES[i];
    if (ratingType === "numbers") return `${i + 1}`;
    return "⭐";
  };

  return (
    <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={glassCard}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#1f2937" }}>Skip Option</Typography>
            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>Allow visitors to skip this question</Typography>
          </Box>
          <Switch checked={skipOption} onChange={(e) => setSkipOption(e.target.checked)} size="small" />
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Rating Type</Typography>
        <ToggleButtonGroup value={ratingType} exclusive size="small" fullWidth
          onChange={(_, v) => v && setSettings({ ...settings, ratingType: v })}
          sx={{ "& .MuiToggleButton-root": { textTransform: "none", fontSize: 12, fontWeight: 600, flex: 1 } }}>
          <ToggleButton value="smilies">😀 Smilies</ToggleButton>
          <ToggleButton value="stars">⭐ Stars</ToggleButton>
          <ToggleButton value="numbers">🔢 Numbers</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1.5, color: "#1f2937" }}>Rating Options</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {[0, 1, 2, 3, 4].map(i => (
            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1.5, p: 1, bgcolor: "rgba(249,250,251,0.8)", borderRadius: 2, border: "1px solid #f3f4f6" }}>
              <Box sx={{ width: 36, textAlign: "center" }}>
                <Typography sx={{ fontSize: ratingType === "stars" ? 14 : 20 }}>{getPreview(i)}</Typography>
              </Box>
              <TextField fullWidth size="small" placeholder={DEFAULT_LABELS[i]}
                value={ratingLabels[i] || ""} onChange={(e) => handleLabelChange(i, e.target.value)}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
            </Box>
          ))}
        </Box>
      </Box>

      <Box sx={glassCard}>
        <Typography sx={{ fontWeight: 600, fontSize: 13, mb: 1, color: "#1f2937" }}>Error Message</Typography>
        <TextField fullWidth placeholder="Please select a rating" value={errorMessage} size="small"
          onChange={(e) => setErrorMessage(e.target.value)}
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, bgcolor: "#fff", fontSize: 12 } }} />
      </Box>
    </Box>
  );
};

export default RatingTab;
